import { useCustomer } from './useCustomer';

export const useIsUserLoggedIn = () => {
  const { customer } = useCustomer();
  return !!customer?.id;
};
